/**
 * @description 将字符串转换为数组, 先用正则判断是否为数组字符串, 如果不是则直接返回原值，如果是则删掉两边的中括号后转换为数组
 * @param {string} str 字符串
 * @returns {string[]} 数组
 * @example "['April', 'May', 'June']" => ["April", "May", "June"]
 * 
 */

// 正则判断是否为数组字符串
const isMaybeArray = (str: string) => /^\s*\[.*\]\s*$/.test(str);

export const convertArrayStringToArray = (str: string): string[] | string => {
  if (isMaybeArray(str)) {
    return str.slice(1, -1).split(',').map(item => item.trim().slice(1, -1)) // 删除前后括号及item前后引号
  }
  return str
}
